
import React from 'react';
import { MerchantProfileList } from '../components/MerchantProfileList';

const Layout = ({ children }: { children: React.ReactNode }) => (
  <div className="min-h-screen bg-background">
    <header className="border-b">
      <div className="container mx-auto px-4 py-4">
        <h1 className="text-2xl font-bold">ProPay Simulator Admin</h1>
      </div>
    </header>
    <main className="container mx-auto px-4 py-8">
      {children}
    </main>
  </div>
);

const MerchantProfilesPage = () => (
  <Layout>
    <div className="max-w-6xl mx-auto">
      <div className="mb-6">
        <a
          href="/"
          className="inline-flex items-center text-sm text-muted-foreground hover:text-foreground mb-4"
        >
          ← Back to Home
        </a>
        <div>
          <h2 className="text-2xl font-bold mb-2">Merchant Profiles</h2>
          <p className="text-muted-foreground">
            View and manage merchant profiles with payment processor configurations.
          </p>
        </div>
      </div>

      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
        <h3 className="font-medium text-blue-900 mb-2">About Merchant Profiles</h3>
        <p className="text-sm text-blue-800">
          Merchant profiles contain the detailed payment processor configuration and credentials.
          Each profile has a unique ID and includes processor-specific data like certificates,
          account numbers, and terminal IDs needed for payment processing.
        </p>
      </div>

      <MerchantProfileList />
    </div>
  </Layout>
);

export default MerchantProfilesPage;
